import {enabledLanguages} from '@daedalus/core/src/localization/services/locale'

import {Language} from '../types/partnersApi/types'

const DEFAULT_LANGUAGE = 'en'

export const getLanguageFromBrowser = () => {
  const navigatorLanguage = navigator.language
  if (enabledLanguages.includes(navigatorLanguage)) {
    return navigatorLanguage as NonNullable<Language>
  }

  return DEFAULT_LANGUAGE
}
